"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Option = function Option() {
  return null;
};

Option.isSelectOption = true;
Option.displayName = 'ASelectOption';
var _default = Option;
exports.default = _default;